import React from "react";
import { Box } from "@mui/material";
import ImagenLogin from "../../../components/ImagenLogin";
import Login from "./Login";

const MenuLogin = () => {
    return(
        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: { xs: 'column', sm: 'column', md: 'row-reverse' }, 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                width: '100%', 
                minHeight: '100vh', 
            }}
        >
            <ImagenLogin/>
            <Login/>
        </Box>
    );
}

export default MenuLogin;